export default __webpack_public_path__ + "static/media/stormcrown.f7f0c521.png";